import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["ComplaintForm"] */ "/vercel/path0/src/components/complaint-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroNavImage"] */ "/vercel/path0/src/components/hero-nav-image.tsx");
